/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-console */
/* eslint-disable import/no-named-as-default */
/* eslint-disable react/no-unused-prop-types */
import { Fragment, useEffect, useState } from 'react';
import NoSSR from 'react-no-ssr';
import classNames from 'classnames';

import {
  getPagePath,
  useSoyuzClientConfig,
  useSoyuzExperiment
} from '@spotahome/soyuz/client';
import PropTypes from 'prop-types';
import Metrics from '@spotahome/soyuz-tracking';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import {
  BackButton,
  Header,
  MediaQuery,
  SearchBreadcrumbs,
  useCityName,
  useCityInfo,
  useModalHandle
} from '@spotahome/ui-library';
import { isStandardPlan } from '@spotahome/ui-library/src/utils/plans';
import {
  formatDate,
  addDaysToDate
} from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';
import BackButtonDesktop from '@spotahome/ui-library/src/tenant/components/BackButtonDesktop';
import SectionContentNavigation from '@spotahome/ui-library/src/tenant/components/SectionContentNavigation';

import { ListingShape } from '@spotahome/marketplace-common/src/shapes/listing';
import internalLinkingModule from '@spotahome/marketplace-common/src/shapes/internalLinking';
import InternalLinkingModules from '@spotahome/marketplace-common/src/components/internalLinking/InternalLinkingModules';
import ListingSocialButtons from '@spotahome/marketplace-common/src/components/ListingSocialButtons';
import ListingPaymentInfoModal from '@spotahome/marketplace-common/src/components/ListingPaymentInfoModal';
import getGqlClient from '@spotahome/marketplace-common/src/graphql/client';
import { trackListingVisit } from '@spotahome/marketplace-common/src/graphql/mutations/listing-events';

import JsonLdVideo from '@spotahome/marketplace-common/src/LEGACY/javascripts/microdata/components/JsonLdVideo';

import { getPriceRange } from '../utils/getPriceRange';
import { getListingAnchorText } from '../utils/getListingAnchorText';
import { getRnaIdFeature } from '../utils/legalFeaturesAdapter';
import { getNavigationItems } from '../utils/getNavigationItems';

import { SliderProvider } from '../context/SliderContext';

import JsonLdProduct from '../structuredData/JsonLdProduct';

import { BOOKING_STATUSES } from '../constants';

import { BrusselsWatermark } from './VideoWatermarks';

import BookNowModal from './BookNowModal';
import ListingInformation from './ListingInformation';
import MobileBookNow from './MobileBookNow';
import ListingsAround from './ListingsAround';
import Slider from './Slider';
import PropertyTitle from './PropertyTitle';
import SimplifiedPropertyTitle from './PropertyTitle/SimplifiedPropertyTitle';
import ListingBookNowCard from './ListingBookNowCard';

import WorryFreeDeposit from './WorryFreeDeposit';

import ExtendedLandlordInformationModal from './ExtendedLandlordInformationModal';

import BookingBarNotAvailable from './BookingBarNotAvailable/BookingBarNotAvailable';

import './Listing.scss';

const WHOLE_PROPERTY_TYPES = ['whole', 'studio'];
const INCLUDED_DAY = 1;

const MOVE_INTERVAL = 180;

const { UntilTablet } = MediaQuery;

const removeHtmlTags = text => (text ? text.replace(/<(.|\n)*?>/g, '') : '');

const getAssumedMoveOut = (newMoveIn, minStay) => {
  return formatDate(addDaysToDate(newMoveIn, minStay - INCLUDED_DAY));
};

const handleBackClick = cityId => e => {
  if (e) {
    e.preventDefault();
  }

  if (typeof window !== 'undefined') {
    const comesFromSpotahome =
      document.referrer &&
      (document.referrer.includes('spotahome') ||
        document.referrer.includes('localhost') ||
        document.referrer.includes('erasmusu'));

    if (!comesFromSpotahome) {
      const searchPageUrl = getPagePath('marketplace.search', {
        params: {
          city: cityId
        }
      });
      window.location.href = searchPageUrl;
    } else {
      window.history.back();
    }
  }
};

const handleBackClickDesktop = () => {
  SoyuzAnalytics.sendGA4Event('send', {
    action: 'go-back',
    section: 'listing-page'
  });
};

const getBackPagePath = cityId => {
  let referrer = '';
  if (typeof document !== 'undefined') {
    referrer = document.referrer || '';
  }

  const baseSearchPageUrl = getPagePath('marketplace.free-search', {
    params: {
      locationString: cityId
    }
  });

  return referrer.includes(baseSearchPageUrl) ? referrer : baseSearchPageUrl;
};

const Listing = ({
  listing,
  locale: initialLocale,
  moveIn = '',
  moveOut = '',
  onBookingDatesChange,
  deviceType,
  isRoomsAggregator,
  isWholeApartment,
  hasGAP = false,
  bookingStatus,
  hideHeader,
  deviceOS = '',
  listingCanonicalUrl,
  internalLinking,
  landlordHomecards = []
}) => {
  const { minStay = MOVE_INTERVAL } = listing;
  const { hasVetting, hasRentCollection } = listing.bookingConditions;
  const { DEFAULT_LOCALE } = useSoyuzClientConfig();
  const content =
    listing.contents[initialLocale] || listing.contents[DEFAULT_LOCALE];

  const [showSlider, setShowSlider] = useState(false);
  const [showTranslatedContent, setShowTranslatedContent] = useState(true);
  const [locale, setLocale] = useState(
    showTranslatedContent && listing.contents[initialLocale]
      ? initialLocale
      : DEFAULT_LOCALE
  );

  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();

  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeaderV2').get('behaviour') ===
    'variant';

  const isListingSimplificationBottomVariant =
    useSoyuzExperiment('ListingSimplificationBottom').get('behaviour') ===
    'variant';

  const isListingPaymentsModuleVariant =
    useSoyuzExperiment('ListingPaymentsModule').get('behaviour') === 'variant';

  useEffect(() => {
    if (moveIn && !listing.allowsPermanentContract) {
      onBookingDatesChange({
        moveIn,
        moveOut: moveOut || getAssumedMoveOut(moveIn, minStay)
      });
    }
  }, []);

  useEffect(() => {
    if (!isStandardPlan(listing.plan) && hasVetting) {
      Metrics.hotjar.recordTag(listing.plan);
    }
  }, []);

  useEffect(() => {
    trackListingVisit(getGqlClient())(listing.id);
  }, []);

  const handleChangeLanguage = () => {
    const availableLocales = Object.keys(listing.contents);
    const selectedLocale = availableLocales.find(
      availableLocale => availableLocale !== locale
    );

    if (selectedLocale) {
      setLocale(selectedLocale);
      setShowTranslatedContent(!showTranslatedContent);
    }
  };

  const getContents = key =>
    (listing.contents[locale] || listing.contents[DEFAULT_LOCALE])[key];
  const getTranslatedContent = key =>
    content[key] ?? listing.contents[DEFAULT_LOCALE][key];

  const getTitle = () => {
    if (isRoomsAggregator) {
      return getContents('propertyTitle') || getContents('title');
    }
    return getContents('title');
  };

  const getSliderMapProps = () =>
    isRoomsAggregator
      ? null
      : {
          coords: listing.coords,
          countryCode: listing.countryCode,
          areaSlug: listing.areaInfo.slug,
          limits: listing.areaInfo.limits
        };

  const getBookingRequestFormUrl = () => {
    const { allowsTemporalContract, allowsPermanentContract } = listing;

    if (!moveIn || (!moveOut && !allowsPermanentContract)) {
      return '';
    }
    const checkOut = allowsTemporalContract ? moveOut : '';
    return getPagePath('booking-form', {
      params: {
        city: listing.cityId,
        listingId: listing.id,
        checkIn: moveIn,
        ...(checkOut ? { checkOut } : {})
      }
    });
  };

  const getVideoWatermark = () =>
    listing.verificationDate !== null && listing.cityId === 'brussels' ? (
      <BrusselsWatermark verificationDate={listing.verificationDate} />
    ) : null;

  const isPropertyWhole = () => WHOLE_PROPERTY_TYPES.includes(listing.type);

  const hasMoreRooms = () => {
    const currentRoomId = !isRoomsAggregator ? listing.id : null;
    const roomsInApartment = listing.roomsInApartment || [];

    return !!roomsInApartment.filter(room => room.id !== currentRoomId).length;
  };

  const mustShowLanguageToggle = () => {
    if (!listing.contents[locale]) {
      return true;
    }

    const isManualTranslated = getContents('isManualTranslated');
    const isTranslationNeeded = getContents('isTranslationNeeded');

    const hasContent = Object.keys(listing.contents).length > 1;

    return (
      hasContent &&
      (!showTranslatedContent || !isManualTranslated || isTranslationNeeded)
    );
  };

  const handleCloseVideo = () => setShowSlider(false);

  const renderBookNowBar = () => {
    if (isModalOpen) {
      return null;
    }

    if (isRoomsAggregator || !listing.isBookable) {
      return null;
    }

    if (listing.moveInDatesRanges.length === 0) {
      return <BookingBarNotAvailable />;
    }

    const showPrice = !!moveIn;

    return (
      <MobileBookNow
        countryCode={listing.countryCode}
        landlordPolicies={getContents('landlordPolicies')}
        pricing={listing.pricing}
        moveIn={moveIn}
        moveOut={moveOut}
        onClick={handleModalOpen}
        showPrice={showPrice}
        isBookable={listing.isBookable}
        hasRentCollection={hasRentCollection}
      />
    );
  };

  const adTitle = getTitle();
  const bookingRequestFormUrl = getBookingRequestFormUrl();
  const { lowPrice, highPrice } = getPriceRange(
    isRoomsAggregator,
    listing.roomsInApartment
  );

  const isMobile = deviceType === 'smartphone';

  const listingClasses = classNames('listing', {
    'listing--listing-simplification-bottom':
      isListingSimplificationBottomVariant,
    'listing--simplification-header-variant':
      isListingSimplificationHeaderVariant
  });

  const backButtonClases = classNames('listing__back-button-desktop', {
    'listing__back-button-desktop--simplification-header-variant':
      isListingSimplificationHeaderVariant
  });

  const cityInfo = useCityInfo(listing.cityId);
  return (
    <Fragment>
      {!hideHeader && isMobile && !isListingSimplificationHeaderVariant && (
        <Header
          className="listing__header"
          logo={null}
          menuIcon={
            <BackButton
              dataTest="mobile-back-button"
              onClick={handleBackClick(listing.cityId)}
              size="small"
            />
          }
          renderExtraContent={() => (
            <ListingSocialButtons
              deviceType={deviceType}
              listingId={listing.id}
              deviceOS={deviceOS}
            />
          )}
        />
      )}
      {!isMobile && isListingSimplificationHeaderVariant && (
        <BackButtonDesktop
          className={backButtonClases}
          dataTest="mobile-back-desktop"
          onClick={handleBackClickDesktop}
          href={getBackPagePath(listing.cityId)}
          size="small"
          color="link"
          textKey="page.link.back"
          underline
        />
      )}
      <div className={listingClasses}>
        {isListingSimplificationHeaderVariant && (
          <div className="listing__top">
            {!isMobile && (
              <SimplifiedPropertyTitle
                title={getTitle()}
                type={listing.type}
                details={{
                  m2: listing.m2,
                  ...listing.details
                }}
                listingId={listing.id}
              />
            )}
            <SliderProvider isChecked={listing.checked}>
              <Slider
                adTitle={adTitle}
                hasOtherRooms={!isPropertyWhole() && hasMoreRooms()}
                showVideo={showSlider}
                videoWatermark={getVideoWatermark()}
                handleCloseVideo={handleCloseVideo}
                map={getSliderMapProps()}
                listingId={listing.id}
                videos={listing.videos}
                deviceType={deviceType}
                floorplanList={listing.photos.floorplanList}
                photoList={listing.photos.photoList}
                photo360List={listing.photos.photo360List}
                onBackClick={handleBackClick(listing.cityId)}
              />
            </SliderProvider>
          </div>
        )}
        <div className="listing__grid">
          <div className="listing__content">
            {!isMobile && !isListingSimplificationHeaderVariant && (
              <BackButtonDesktop
                className="listing__back-button-desktop"
                dataTest="mobile-back-desktop"
                onClick={handleBackClickDesktop}
                href={getBackPagePath(listing.cityId)}
                size="small"
                color="link"
              />
            )}
            {!isListingSimplificationHeaderVariant && (
              <SliderProvider isChecked={listing.checked}>
                <Slider
                  adTitle={adTitle}
                  hasOtherRooms={!isPropertyWhole() && hasMoreRooms()}
                  showVideo={showSlider}
                  videoWatermark={getVideoWatermark()}
                  handleCloseVideo={handleCloseVideo}
                  map={getSliderMapProps()}
                  listingId={listing.id}
                  videos={listing.videos}
                  deviceType={deviceType}
                  floorplanList={listing.photos.floorplanList}
                  photoList={listing.photos.photoList}
                  photo360List={listing.photos.photo360List}
                />
              </SliderProvider>
            )}
            {isMobile && isListingSimplificationHeaderVariant && (
              <SimplifiedPropertyTitle
                className="listing__property-title"
                title={getTitle()}
                type={listing.type}
                details={{
                  m2: listing.m2,
                  ...listing.details
                }}
                listingId={listing.id}
                showSocialButtons={false}
                isChecked={listing.checked}
              />
            )}
            {!isListingSimplificationHeaderVariant && (
              <PropertyTitle
                title={getTitle()}
                type={listing.type}
                details={{
                  m2: listing.m2,
                  ...listing.details
                }}
                cityId={listing.cityId}
                isBestChoice={listing.isBestChoice}
                listingId={listing.id}
                plan={listing.plan}
                bills={listing.bills}
                isChecked={listing.checked}
                instantBooking={listing.instantBooking}
                allowsPermanentContract={listing.allowsPermanentContract}
                homechecker={listing.runner}
                verificationDate={listing.verificationDate}
                landlordType={listing.landlordType}
                landlordId={listing.landlordId}
                countryCode={listing.countryCode}
                statistics={listing.statistics}
                landlordScoring={listing.landlordScoring}
                hasDepositProtection={
                  listing.bookingConditions?.hasDepositProtection
                }
                rnaIdFeature={getRnaIdFeature(
                  listing.type,
                  listing.propertyFeatures,
                  listing.unitFeatures
                )}
              />
            )}
          </div>

          {!isRoomsAggregator ? (
            <div className="listing__sidebar">
              {isListingSimplificationHeaderVariant &&
                listing.bookingConditions?.hasDepositProtection && (
                  <WorryFreeDeposit />
                )}
              <ListingBookNowCard
                listing={listing}
                deviceType={deviceType}
                moveIn={moveIn}
                moveOut={moveOut}
                bookingStatus={bookingStatus}
                hasGAP={hasGAP}
                onBookingDatesChange={onBookingDatesChange}
                bookingRequestFormUrl={bookingRequestFormUrl}
              />
            </div>
          ) : null}

          <div className="listing__content">
            {!isListingSimplificationHeaderVariant && (
              <SectionContentNavigation
                eventPrefix="listing"
                items={getNavigationItems({
                  hasSurroundings: !!getContents('transportation'),
                  hasReviews: listing.reviews && listing.reviews.count > 0,
                  isRoomsAggregator,
                  hidePricingSection: !isListingPaymentsModuleVariant || isRoomsAggregator,
                  isListingSimplificationBottomVariant
                })}
                className="listing__content-navigation"
              />
            )}
            <ListingInformation
              isRoomsAggregator={isRoomsAggregator}
              isWholeApartment={isWholeApartment}
              locale={locale}
              moveIn={moveIn}
              moveOut={moveOut}
              listing={listing}
              onLanguageChange={handleChangeLanguage}
              mustShowLanguageToggle={mustShowLanguageToggle()}
              showTranslatedContent={showTranslatedContent}
              deviceType={deviceType}
              landlordHomecards={landlordHomecards}
            />
            <SearchBreadcrumbs
              cityName={useCityName(listing.cityId)}
              cityId={listing.cityId}
              countryId={cityInfo?.country?.countryId}
              propertyType={[listing.ptype.title]}
              anchorText={getListingAnchorText(
                listing.address,
                listing.adId,
                listing.type,
                isWholeApartment
              )}
              className={classNames('listing__breadcrumb', {
                'listing__breadcrumb--large':
                  isListingSimplificationBottomVariant
              })}
            />
          </div>
        </div>
        {isListingSimplificationBottomVariant && (
          <ListingsAround
            moveIn={moveIn}
            moveOut={moveOut}
            listingId={listing.adId}
          />
        )}
      </div>

      {!isListingSimplificationBottomVariant && (
        <ListingsAround
          moveIn={moveIn}
          moveOut={moveOut}
          listingId={listing.adId}
        />
      )}
      <section>
        <InternalLinkingModules internalLinking={internalLinking} />
      </section>
      <NoSSR>
        <UntilTablet>{renderBookNowBar()}</UntilTablet>
      </NoSSR>
      <JsonLdProduct
        description={getTranslatedContent('seoMetaDescription')}
        highPrice={highPrice}
        isRoomsAggregator={isRoomsAggregator}
        lowPrice={lowPrice}
        name={getTranslatedContent('title')}
        offerCount={listing.roomsInApartment.length}
        price={listing.pricing.price}
        priceCurrency={listing.pricing.currencyLabel}
        url={listingCanonicalUrl}
        reviews={listing.reviews}
        listingId={listing.id}
        title={getTranslatedContent('title')}
        review={removeHtmlTags(getTranslatedContent('description'))} // Not sure what this is.
        photoList={listing.photos.photoList}
        features={listing.propertyFeatures}
      />
      {listing.videos.map(video => (
        <JsonLdVideo
          key={video.embedUrl}
          name={content?.title || video.name}
          description={
            content?.description ||
            video.description ||
            getTranslatedContent('title')
          }
          embedUrl={video.embedUrl}
          thumbnailUrl={video.thumbnailUrl}
          uploadDate={video.uploadDate}
        />
      ))}
      <BookNowModal
        onOpenDatePickerEvent={handleModalOpen}
        bookingRequestFormUrl={bookingRequestFormUrl}
        bookingStatus={bookingStatus}
        hasGAP={hasGAP}
        isOpen={isModalOpen}
        listing={listing}
        landlordPolicies={getContents('landlordPolicies')}
        moveIn={moveIn}
        moveOut={moveOut}
        onBookingDatesChange={onBookingDatesChange}
        onRequestClose={handleModalClose}
        title={adTitle}
        cityId={listing.cityId}
        hasRentCollection={hasRentCollection}
      />
      <ListingPaymentInfoModal
        currencyIsoCode={listing.pricing.currencyLabel}
        countryCode={listing.countryCode}
        landlordPolicies={getContents('landlordPolicies')}
        hasRentCollection={hasRentCollection}
        hasDepositProtection={listing.bookingConditions?.hasDepositProtection}
        listingCosts={listing.listingCosts}
        onDatesChange={onBookingDatesChange}
        minStay={listing.minStay}
        maxStay={listing.maxStay}
        availabilities={listing.availabilities}
        moveInDatesRanges={listing.moveInDatesRanges}
        contractDurationTypesAllowed={listing.contractDurationTypesAllowed}
      />
      <ExtendedLandlordInformationModal />
    </Fragment>
  );
};

Listing.propTypes = {
  hasGAP: PropTypes.bool,
  isRoomsAggregator: PropTypes.bool.isRequired,
  isWholeApartment: PropTypes.bool.isRequired,
  listing: PropTypes.shape(ListingShape).isRequired,
  listingCanonicalUrl: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string,
  onBookingDatesChange: PropTypes.func.isRequired,
  hideHeader: PropTypes.bool.isRequired,
  hideLinking: PropTypes.bool.isRequired,
  bookingStatus: PropTypes.oneOf(Object.values(BOOKING_STATUSES)).isRequired,
  deviceType: PropTypes.oneOf(['smartphone', 'tablet', 'desktop']).isRequired,
  deviceOS: PropTypes.string,
  userId: PropTypes.string,
  internalLinking: PropTypes.arrayOf(PropTypes.shape(internalLinkingModule))
    .isRequired,
  landlordHomecards: PropTypes.arrayOf(PropTypes.object),
  showShareButtonStatistics: PropTypes.bool
};

export default Listing;
